
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 147 124","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none"}},[_c('path',{attrs:{"d":"M138.04 24c4.928 0 8.96 3.988 8.96 8.86v82.28c0 4.873-4.032 8.86-8.96 8.86H8.96C4.032 124 0 120.012 0 115.14V32.86C0 27.986 4.032 24 8.96 24h129.08zm-60.4 76.46h-62v10h62v-10zm45.402-13.142c-2.297 0-4.432.7-6.214 1.9a11.077 11.077 0 00-6.213-1.9c-6.233 0-11.287 5.15-11.287 11.5 0 6.352 5.054 11.5 11.287 11.5 2.296 0 4.43-.7 6.213-1.898a11.099 11.099 0 006.214 1.898c6.233 0 11.286-5.148 11.286-11.5 0-6.35-5.053-11.5-11.286-11.5zm-67.024-5h-40v10h40v-10z","fill":"var(--legend-c-text)"}}),_c('path',{attrs:{"d":"M101.648 20.522L90.608 1.478C90.139.665 88.983 0 88.04 0H65.961c-.941 0-2.098.665-2.568 1.478l-11.04 19.044c-.47.813-.47 2.142 0 2.955l11.039 19.045c.47.813 1.627 1.478 2.568 1.478h22.08c.94 0 2.097-.665 2.568-1.478l11.039-19.045c.47-.813.47-2.142 0-2.955h.001z","fill":"#F41B14"}}),_c('path',{attrs:{"fill":"#FFF","d":"M78.74 10.16l-.507 17.368h-2.465l-.507-17.368zm-1.775 24.733c-1.233 0-2.103-.975-2.103-2.24 0-1.3.906-2.238 2.175-2.238 1.269 0 2.103.939 2.103 2.239 0 1.264-.834 2.24-2.175 2.24z"}})])])
          )
        }
      }
    